/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';

import exportWithBoundary from '../../../helpers/exportWithBoundary';
import { AvatarContainer, AvatarImage } from './styles';

function Avatar(props) {
  const { imageUrl, icon, text, size, onClick } = props;

  let iconSize = 20;
  if (size === 'sm') {
    iconSize = 16;
  }
  if (size === 'lg') {
    iconSize = 40;
  }

  let avatarContent = text || '';
  if (icon) {
    avatarContent = <i className={`icon-${icon} icon--${iconSize}`} />;
  }
  if (imageUrl) {
    avatarContent = (
      <AvatarImage style={{ backgroundImage: `url(${imageUrl})` }} />
    );
  }

  return (
    <AvatarContainer role='presentation' onClick={onClick} {...props}>
      {avatarContent}
    </AvatarContainer>
  );
}

Avatar.defaultProps = {
  imageUrl: null,
  icon: null,
  text: null,
  size: 'lg',
  color: null,
  onClick: () => {},
};

Avatar.propTypes = {
  imageUrl: PropTypes.string,
  icon: PropTypes.string,
  text: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
};

function AvatarFallback() {
  return <AvatarContainer />;
}

export default exportWithBoundary(Avatar, AvatarFallback);
